var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.227,
    height: 18.227,
    viewBox: "0 0 18.227 18.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".edit-class,.edit-class2{fill:none;}.edit-class2{stroke:#0d0d0d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.114 0.114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-481 -4384)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(137 -848)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "edit-class",
    width: 18,
    height: 18,
    transform: "translate(344 5232)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "edit-class",
    width: 18,
    height: 18,
    transform: "translate(345 5233)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.637 5233.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "edit-class2",
    d: "M9.482,4H3.663A1.663,1.663,0,0,0,2,5.663V17.3a1.663,1.663,0,0,0,1.663,1.663H15.3A1.663,1.663,0,0,0,16.963,17.3V11.482",
    transform: "translate(-2 -2.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit-class2",
    d: "M16.729,2.4a1.763,1.763,0,0,1,2.494,2.494l-7.9,7.9L8,13.618l.831-3.325Z",
    transform: "translate(-3.012 -1.879)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.67494701fc30417918860d3f40758c17.svg";
export { ForwardRef as ReactComponent };